import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

// 🔒 Utilities
const safeLabels = (arr) =>
  Array.isArray(arr) ? arr.map((x) => String(x ?? "Unknown")) : [];

const safeSeries = (series) =>
  Array.isArray(series)
    ? series.map((s) => ({
        ...s,
        data: Array.isArray(s.data) ? s.data.map((v) => Number(v) || 0) : [],
      }))
    : [{ data: [] }];

const BarChart = ({
  title = "",
  labels = [],
  series = [],
  colors = [],
  exportEnabled = true,
  stacked = false,
  headerContent = null,
}) => {
  const [chartSeries, setChartSeries] = useState([{ data: [] }]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setChartSeries(safeSeries(series)); // ✅ always sanitized
    }, 100);
    return () => clearTimeout(timer);
  }, [series]);

  const options = {
    chart: {
      // type: "bar",
      // stacked,
      // toolbar: {
      //   show: false,
      //   tools: { download: exportEnabled },
      // },
      type: "bar",
      stacked,
      parentHeightOffset: 0,
      toolbar: {
        show: false,
        tools: { download: exportEnabled },
      },
      animations: {
        enabled: true,
        easing: "easeout",
        speed: 1200,
        animateGradually: { enabled: true, delay: 200 },
        dynamicAnimation: { enabled: true, speed: 800 },
      },
    },
    colors,
    plotOptions: {
      bar: {
        borderRadius: 6,
        horizontal: false,
        columnWidth: "55%",
        startingShape: "flat",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -10,
      style: { fontSize: "12px", colors: ["#f7f7f7ff"] },
    },
    // xaxis: {
    //   categories: safeLabels(labels), // ✅ always strings
    //   labels: { rotate: -45 },
    // },
    xaxis: {
      categories: safeLabels(labels),
      labels: {
        rotate: -60,
        trim: true, // ✅ trims the end if label too long
        offsetX: 0, // ✅ keeps first letter aligned
        style: {
          fontSize: "12px",
          cssClass: "apexcharts-xaxis-label", // we can target with CSS
        },
        //   formatter: (val) =>
        // val && val.length > 10 ? val.substring(0, 13) + "…" : val, // ✅ only 10 chars
      },
    },
    grid: {
      borderColor: "#f1f1f1",
      padding: {
        left: 0, // ✅ no extra space, first letter always visible
        right: 20, // ✅ allow overflow on the right (last letters can hide)
      },
    },
    yaxis: {
      reversed: false,
      labels: { formatter: (val) => (isNaN(val) ? "0" : val.toFixed(0)) },
    },
    title: {
      text: typeof title === "string" ? title : "",
      align: "left",
      style: { fontSize: "16px", fontWeight: "bold" },
    },
    legend: { position: "top" },
    tooltip: {
      theme: "light",
      y: { formatter: (val) => `${val}` },
    },
    // grid: { borderColor: "#f1f1f1" },
  };

  return (
    <div>
      {headerContent && <>{headerContent}</>}
      <Chart options={options} series={chartSeries} type="bar" height={413} />
    </div>
  );
};

export default BarChart;
